module.exports = __webpack_public_path__ + "img/main_mgcafee.0ceeb9f7.png";